module.exports = __webpack_public_path__ + "4bbe703de4a5851aefce47d5af2cb049.png";